import { UserApi } from './user-api.model';

export class User {
  name: string;
  email: string;
  phone: string;
  realEstate: string;
  creci: string;
  regionId: string | null;

  constructor(resource: UserApi) {
    this.name = resource.name;
    this.email = resource.email;
    this.phone = resource.cellphone;
    this.realEstate = resource.real_estate;
    this.creci = resource.creci;
    this.regionId = resource.region_id !== null
                    ? String(resource.region_id)
                    : null;
  }
}
